import { mapGetters, mapActions, mapState } from 'vuex'
import { formatCurrency } from '@utils/currency-helpers'
/**
 * Handle basic shared functionality for room-list and room-rates pages of the booking wizard
 */
export default {
  computed: {
    ...mapGetters('rooms', ['roomsAvailable']),
    ...mapState('rooms', ['loadingRooms']),
    ...mapGetters('i18n', ['tc']),
    ...mapState('booking', { bookingReady: 'ready' }),
    room() {
      return this.roomsAvailable.find(r => r.synXisID === this.$route.params.id)
    },
    bedType() {
      if (!this.room) {
        return null
      }
      const betTypeCode = this.$route.query.bedTypeCode
      return betTypeCode ? this.room.bedType.find(b => b.synXisID === betTypeCode) : this.room.bedType[0]
    }
  },
  watch: {
    /**
     * @vuese
     * On page reload and bookingReady check if there are any rooms available in the store
     * and if not make the availability request
     */
    bookingReady(val) {
      if (val && this.roomsAvailable.length === 0 && !this.loadingRooms) {
        this.getAvailableRooms()
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      if (vm.roomsAvailable.length === 0 && vm.bookingReady && !vm.loadingRooms) {
        await vm.getAvailableRooms()
      }
      return true
    })
  },
  mounted() {
    if (this.bookingReady) {
      this.trackAvailabilityCall()
    }
  },
  methods: {
    ...mapActions('rooms', ['getAvailableRooms', 'trackAvailabilityCall']),
    ...mapActions('cart', ['resetRoomUpgrades'])
  },
  filters: {
    currencyFilter(number) {
      return formatCurrency(number)
    }
  }
}
